import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import { FormattedMessage } from '../../util/reactIntl';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { useIntl } from 'react-intl'

import css from './FAQPage.module.css';

const FAQPage = () => {
  const intl = useIntl();
  const schemaTitle = intl.formatMessage( {id:"FAQPage.schemaTitle"});
  const schemaDecription = intl.formatMessage( {id:"FAQPage.schemaDescription"})
  // prettier-ignore
  return (
    <StaticPage
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        description: schemaDecription,
        name: 'FAQ page',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Question 1?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Answer: Lorem ipsum',
            },
          },
        ],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.mainWrapper}>
          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <ul>
                <li className={css.faqCategory}>
                  <a href="#travellers-faq">
                    <FormattedMessage id="FAQPage.travellersLink" />
                  </a>
                </li>
                <li className={css.faqCategory}>
                  <a href="#affiliates-faq">
                    <FormattedMessage id="FAQPage.SALink" />
                  </a>
                </li>
                <li className={css.faqCategory}>
                  <a href="#tour-operators-faq">
                    <FormattedMessage id="FAQPage.TOLink" />
                  </a>
                </li>
                <li className={css.faqCategory}>
                  <a href="#safety-faq">
                    <FormattedMessage id="FAQPage.SafetyTipsLink" />
                  </a>
                </li>
                <li className={css.faqCategory}>
                  <a href="#covid-faq">
                    <FormattedMessage id="FAQPage.CovidLink" />
                  </a>
                </li>
              </ul>
            </div>
            <div className={css.contentMain}>
              <h1 className={css.faqTitle} id="#top">
                <FormattedMessage id="FAQPage.title" />
              </h1>
              <span className={css.anchor} id="travellers-faq"></span>
              <div>
                <h2 className={css.topic}>
                  <FormattedMessage id="FAQPage.travellersTitle" />
                </h2>
                <ol>
                  {/* Question 1 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ01" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA01" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 2 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ02" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA02" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 3 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ03" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA03" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 4 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ04" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA04" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 5 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ05" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA05" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 6 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ06" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA06" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 7 */}
                  <li className={css.question}>
                    {' '}
                    <FormattedMessage id="FAQPage.travellersQ07" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA07" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 8 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ08" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA08" />

                        <ol>
                          <li className={css.orderedNested}>
                            <FormattedMessage id="FAQPage.travellersA081" />{' '}
                          </li>
                          <li className={css.orderedNested}>
                            <FormattedMessage id="FAQPage.travellersA082" />{' '}
                          </li>
                          <li className={css.orderedNested}>
                            <FormattedMessage id="FAQPage.travellersA083" />
                          </li>
                          <li className={css.orderedNested}>
                            <FormattedMessage id="FAQPage.travellersA084" />{' '}
                          </li>
                          <li className={css.orderedNested}>
                            <FormattedMessage id="FAQPage.travellersA085" />
                          </li>
                          <li className={css.orderedNested}>
                            <FormattedMessage id="FAQPage.travellersA086" />

                            <ul>
                              <li className={css.nested}>
                                <FormattedMessage id="FAQPage.travellersA086A" />
                              </li>
                              <li className={css.nested}>
                                <FormattedMessage id="FAQPage.travellersA086B" />
                              </li>
                            </ul>
                          </li>
                        </ol>
                      </li>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA087" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 9 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ09" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA09" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 10 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ10" />
                    <ul>  
                      <li className={css.answer}><FormattedMessage id="FAQPage.travellersA10" />{' '}</li>
                    </ul>
                  </li>
                  {/* Question 11 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ11" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA11" />
                      </li>
                    </ul>
                  </li>
                  {/* Question 12 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ12" />
                    <ul>
                      <li className={css.answer}><FormattedMessage id="FAQPage.travellersA12" />{' '}</li>
                    </ul>
                  </li>
                  {/* Question 13 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ13" />

                    <ul>
                      <li className={css.answer}><FormattedMessage id="FAQPage.travellersA13" /></li>
                    </ul>
                  </li>
                  {/* Question 14 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ14" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA14" />{' '}
                      </li>
                    </ul>
                  </li>
                  {/* Question 15 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ15" />

                    <ul>                      
                      <li className={css.answer}><FormattedMessage id="FAQPage.travellersA15" />{' '}</li>
                    </ul>
                  </li>
                  {/* Question 16 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ16" />

                    <ul>
                      <li className={css.answer}><FormattedMessage id="FAQPage.travellersA16" /></li>
                    </ul>
                  </li>
                  {/* Question 17 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.travellersQ17" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.travellersA17" />
                        <a href="/contactus">
                          <FormattedMessage id="FAQPage.contact" />
                        </a>
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>
              {/* Affiates Questions */}
              <span className={css.anchor} id="affiliates-faq"></span>
              <div>
                <h2 className={css.topic}>
                  <FormattedMessage id="FAQPage.SATitle" />
                </h2>
                <ol>
                  {/* Affiate Question 1 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ01" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA01" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 2 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ02" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA02" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 3 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ03" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA03" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 4 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ04" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA04" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 5 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ05" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA05" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 6 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ06" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA06" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 7 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ07" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA07" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 8 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ08" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA08" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 9 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ09" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA09" />
                      </li>
                    </ul>
                  </li>
                  {/* Affiate Question 10 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.SAQ10" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.SAA10" />
                        <a href="/contactus">
                          <FormattedMessage id="FAQPage.contact" />
                        </a>
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>
              {/* Tour operators Questions */}
              <span className={css.anchor} id="tour-operators-faq"></span>
              <div>
                <h2 className={css.topic}>
                  <FormattedMessage id="FAQPage.TOTitle" />
                </h2>

                <ol>
                  {/* Tour operator Question 1 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ01" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA01" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 2 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ02" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA02" />
                        <a href="/contactus">
                          <FormattedMessage id="FAQPage.contact" />
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 3 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ03" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA03" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 4 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ04" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA04" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 5 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ05" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA05" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 6 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ06" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA06" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 7 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ07" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA07" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 8 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ08" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA08" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 9 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ09" />

                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA09" />
                      </li>
                    </ul>
                  </li>
                  {/* Tour operator Question 10 */}
                  <li className={css.question}>
                    <FormattedMessage id="FAQPage.TOQ10" />
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.TOA10" />
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>
              <span className={css.anchor} id="safety-faq"></span>
              <div>
                <h2 className={css.topic}>
                  <FormattedMessage id="FAQPage.SafetyTitle" />
                </h2>
                <p>
                  <FormattedMessage id="FAQPage.SafetySubtitle" />
                </p>
                <p className={css.question}>
                  <FormattedMessage id="FAQPage.tip01Title" />
                </p>
                <p className={css.answer}>
                  <FormattedMessage id="FAQPage.tip01" />
                </p>
                <p className={css.question}>
                  <FormattedMessage id="FAQPage.tip02Title" />
                </p>
                <p className={css.answer}>
                  <FormattedMessage id="FAQPage.tip02" />
                </p>
                <p className={css.question}>
                  <FormattedMessage id="FAQPage.tip03Title" />
                </p>
                <p className={css.answer}>
                  <FormattedMessage id="FAQPage.tip03" />
                </p>
              </div>
              <span className={css.anchor} id="covid-faq"></span>
              <div>
                <p className={css.topic}>
                  <FormattedMessage id="FAQPage.covidTitle" />
                </p>
                <p className={css.question}>
                  <FormattedMessage id="FAQPage.covidSubtitle" />
                </p>
                <p className={css.answer}>
                  <FormattedMessage id="FAQPage.covid" />
                </p>
                <ol>
                  <li className={css.answer}>
                    <FormattedMessage id="FAQPage.covid01" />
                    <a href="https://www.madeirasafe.com" target="new">
                      <FormattedMessage id="FAQPage.madeirasafeLink" />
                    </a>
                  </li>
                  <li className={css.answer}>
                    <FormattedMessage id="FAQPage.covid02" />
                    <a
                      href="https://covidmadeira.pt/passageiros-podem-realizar-teste-a-covid-19-em-30-postos-de-colheitas/"
                      target="new"
                    >
                      <FormattedMessage id="FAQPage.labsLink" />
                    </a>
                    <ul>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.covid02a" />
                        <a href="https://www.madeirasafe.com" target="new">
                          <FormattedMessage id="FAQPage.madeirasafeLink" />
                        </a>
                      </li>
                      <li className={css.answer}>
                        <FormattedMessage id="FAQPage.covid02b" />
                      </li>
                    </ul>
                  </li>
                  <li className={css.answer}>
                    <FormattedMessage id="FAQPage.covid03" />
                  </li>
                  <ul>
                    <li className={css.answer}>
                      <FormattedMessage id="FAQPage.covid03a" />
                    </li>
                    <li className={css.answer}>
                      <FormattedMessage id="FAQPage.covid03b" />
                    </li>
                    <li className={css.answer}>
                      <FormattedMessage id="FAQPage.covid03c" />
                    </li>
                  </ul>

                  <li className={css.answer}>
                    <FormattedMessage id="FAQPage.covid04" />
                    <a href="https://www.madeirasafe.com" target="new">
                      <FormattedMessage id="FAQPage.madeirasafeLink" />
                    </a>
                  </li>
                  <li className={css.answer}>
                    <FormattedMessage id="FAQPage.covid05" />
                  </li>
                </ol>
                <p className={css.answer}>
                  <FormattedMessage id="FAQPage.moreInfo" />
                </p>
                <ul>
                  <li className={css.linkList}>
                    {' '}
                    <a
                      href="http://www.visitmadeira.pt/pt-pt/info-uteis/corona-virus-(covid-19)/informacoes-aos-visitantes-(covid-19)"
                      target="new"
                    >
                      <FormattedMessage id="FAQPage.visitmadeiraLink" />
                    </a>
                  </li>
                  <li className={css.linkList}>
                    <a
                      href="https://covidmadeira.pt/recomendacao/regras-viagens-para-a-madeira-e-porto-santo/"
                      target="new"
                    >
                      <FormattedMessage id="FAQPage.secretariaregionalLink" />
                    </a>
                  </li>
                </ul>
              </div>
              <a href="#top">
                <p className={css.backToTop}>
                  <FormattedMessage id="FAQPage.linkToTop" />
                </p>
              </a>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FAQPage;
